export const JSON_ONE1 = {
   
  
    "txn_response": 

    {
    
        "ag_id": "string",
        "me_id": "string",
        "order_no": "string",
        "amount": 0,
        "country": "string",
        "currency": "string",
        "txn_date": "string",
        "txn_time": "string",
        "ag_ref": "string",
        "pg_ref": "string",
        "status": "string",
        "res_code": "string",
        "res_message": "string"
    
    },
    "pg_details": 
    {
    
        "pg_id": 0,
        "pg_name": "string",
        "paymode": "string",
        "emi_months": 0
    
    },
    "fraud_details": 
    {
    
        "fraud_action": "string",
        "fraud_message": "string",
        "score": 0
    
    },
    "other_details": 
    {
    
        "udf_1": "string",
        "udf_2": "string",
        "udf_3": "string",
        "udf_4": "string",
        "udf_5": "string"
    
    }
        }

